import { http } from './config'
import authHeader from './auth-header';

export default {

    empresasImportacaoStratws: () => {
        return http.get('/stratus/empresas-importacao-stratws', {
            headers: authHeader()
        })
    },

    importarIndicadoresStratws: (dataInicial, dataFinal, empresa) => {
        return http.post('/stratus/importar-indicadores-stratws', null, {
            params: {
                empresa,
                'data-inicial': dataInicial,
                'data-final': dataFinal,
            },
            headers: authHeader()
        })
    },

    documentos_processo_tecnologia: (dataI, dataF, nomeEmpresa) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/stratus/indicadores_processo_tecnologia', {
           params: params,
           headers: authHeader()   
        })
    },

    documentos_economico_financeiro: (dataI, dataF, nomeEmpresa) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/stratus/documentos_economico_financeiro', {
           params: params,
           headers: authHeader()   
        })
    },

    grafico_indicador_pt: (dataI, dataF, nomeEmpresa, titulo) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'titulo': titulo
        }
        return http.get('/stratus/grafico_indicador_pt', {
           params: params,
           headers: authHeader()   
        })
    },

    grafico_indicador_ef: (dataI, dataF, nomeEmpresa, titulo) => {
        const params = {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'titulo': titulo
        }
        return http.get('/stratus/grafico_indicador_ef', {
           params: params,
           headers: authHeader()   
        })
    },

    getStratwsPrevida: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-previda', {
           params: params,
           headers: authHeader()   
        })
    },

    getStratwsPrevidaXls: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-previda-xls', {
           params: params,
           headers: authHeader(),
           responseType: 'blob'
        })
    },

    getStratwsParque: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-parque', {
           params: params,
           headers: authHeader()   
        })
    },

    getStratwsParqueXls: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-parque-xls', {
           params: params,
           headers: authHeader(),
           responseType: 'blob'
        })
    },

    getStratwsVersan: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-versan', {
           params: params,
           headers: authHeader()   
        })
    },

    getStratwsVersanXls: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-versan-xls', {
           params: params,
           headers: authHeader(),
           responseType: 'blob'
        })
    },

    getStratwsMemorial: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-memorial', {
           params: params,
           headers: authHeader()   
        })
    },

    getStratwsMemorialXls: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-memorial-xls', {
           params: params,
           headers: authHeader(),
           responseType: 'blob'
        })
    },

    getStratwsAgreste: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-agreste', {
           params: params,
           headers: authHeader()   
        })
    },

    getStratwsAgresteXls: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-agreste-xls', {
           params: params,
           headers: authHeader(),
           responseType: 'blob'
        })
    },

    getStratwsMelro: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-melro', {
           params: params,
           headers: authHeader()   
        })
    },

    getStratwsMelroXls: (dataInicial, dataFinal) => {
        const params = {
            'data-inicial': dataInicial,
            'data-final': dataFinal
        }
        return http.get('/stratus/stratws-melro-xls', {
           params: params,
           headers: authHeader(),
           responseType: 'blob'
        })
    },
    
}
